import { memo } from 'react'
import styled from 'styled-components'

// import backgroundBase64 from './config'

const Container = styled.div`
`

export default memo(Container)
